import { pick, isEqual, isEmpty } from 'lodash-es';
import type {
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
  LocationQuery,
} from 'vue-router';

/**
 * @see https://en.wikipedia.org/wiki/UTM_parameters#UTM_parameters
 */
const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_keyword',
  'utm_term',
  'utm_content',
  'gclid',
];

export interface UtmParams extends Record<string, string | undefined> {
  utm_source?: string | undefined;
  utm_medium?: string | undefined;
  utm_campaign?: string | undefined;
  utm_keyword?: string | undefined;
  utm_content?: string | undefined;
  utm_term?: string | undefined;
  gclid?: string | undefined;
}

export function extractUtmFromUrl(): UtmParams {
  const url = new URL(window.location.href);
  const params: UtmParams = {};

  UTM_KEYS.forEach(key => {
    const value = url.searchParams.get(key);
    if (value) {
      params[key as keyof UtmParams] = value;
    }
  });

  return params;
}

const extractUtmFromLocation = (query: LocationQuery) =>
  pick(query, UTM_KEYS) as LocationQuery;

export const getLocationWithUtmTags = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
) => {
  const utmTags = extractUtmFromLocation(from.query);

  if (isEmpty(utmTags)) return;

  const mergedQuery = { ...to.query, ...utmTags };

  if (!isEqual(to.query, mergedQuery)) {
    return { path: to.path, query: mergedQuery };
  }
};
